import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DatePicker, Select, Button, Radio, message } from 'antd';
import 'antd/dist/reset.css';
import './rep-product-report-header.css'
import RepProductFilter from "./rep-product-filter"
import { ExportExcelButton, isMobile, PrintButton } from '../../../extensions/design';
import { useExcelData } from '../rep-excel-data-provider';
import { exportToExcel } from '../../../controls/export-to-excel/export-to-excel';


// Шапка финансового отчета с фильтрами по датам, по кассам, по типам сортировки
function RepProductReportHeader({ filters, onFilterChange, priceType, employeeType, products, onRefresh }) {
  const navigate = useNavigate();
  const [page, setPage] = useState("product");
  const [showFilter, setShowFilter] = useState(false);
  const { excelDataTotal, excelData } = useExcelData();

  useEffect(() => {
    if (excelDataTotal || excelData) {
      console.groupCollapsed("%c[RepFinReportHeader] Получены данные для Excel", "color: #4caf50; font-weight: bold;");
      console.log("excelDataTotal:", excelDataTotal);
      console.log("excelData:", excelData);
      console.groupEnd();
    }
  }, [excelDataTotal, excelData]);

  // Массив для мобильного селектора
  const pages = [
    { title: "Финансовый", link: "fin" },
    { title: "По продажам абонементов, пакетов", link: "abon"},
    { title: "По проданным товарам и оказанным услугам", link: "product"}
  ];

  const customTagRender = (props) => {
    return <span className="filters-tag-label">{props.label}</span>;
  };

  const handlePrint = () => {
    setTimeout(() => {
      window.print();
    }, 500);
  };

  const handleExport = () => {
    try {
      const tables = [];

      // Основная таблица
      if (excelDataTotal?.data?.length) {
        tables.push({
          title: excelDataTotal.title || "Общий отчет",
          colTitle: "Общий отчёт по проданным товарам и услугам",
          columns: excelDataTotal.columns || [],
          data: excelDataTotal.data || [],
        });
      }

      // Детальные таблицы (если excelData — массив)
      if (Array.isArray(excelData)) {
        excelData.forEach((tbl, i) => {
          if (tbl?.data?.length) {
            tables.push({
              title: tbl.title || `Детализация ${i + 1}`,
              colTitle: `Детализация по проданным товарам и услугам`,
              columns: tbl.columns || [],
              data: tbl.data || [],
              summary: tbl.summary || [],
            });
          }
        });
      } 
      // Если excelData — одиночный объект
      else if (excelData?.data?.length) {
        tables.push({
          title: excelData.title || "Детализация",
          colTitle: "Детализация по проданным товарам и услугам",
          columns: excelData.columns || [],
          data: excelData.data || [],
          summary: excelData.summary || [],
        });
      }

      if (!tables.length) {
        message.warning("Нет данных для экспорта");
        return;
      }

      exportToExcel(tables, "Отчёт по проданным товарам, услугам.xlsx");
    } catch (err) {
      console.error("Ошибка при экспорте в Excel:", err);
      message.error("Не удалось выполнить экспорт");
    }
  };

  return (
    isMobile ? 
      (
        <>
        <div className='selector-filer-section' style={{marginTop: 0}}>
            <Select value={page} onChange={(v) => { setPage(v); navigate(`/reports?tab=${v}`); }}>
              {pages.map(p => (
                <Select.Option key={p.link} value={p.link}>
                  {p.title}
                </Select.Option>
              ))}
            </Select>
            <img src="/images/filter.svg" alt="filter" onClick={() => {setShowFilter(!showFilter)}}/>
          </div>
          {showFilter && <RepProductFilter 
            current={filters}
            employeeType={employeeType}
            products={products}
            priceTypes={priceType}
            onRefresh={onRefresh}
            onClose={(newFilters) => {
              if (newFilters) {
                onFilterChange(newFilters);
              }
              setShowFilter(false);
            }}
          />}
        </>
      ) :
      (
        <div className="filters-header-padding">
          <div className="filters-row">
            <span>Период с</span>
            <DatePicker
              value={filters.startDate}
              onChange={value => onFilterChange({startDate: value})}
              format="DD.MM.YYYY"
              allowClear={false}
            />
            <span>по</span>
            <DatePicker
              value={filters.endDate}
              onChange={value => onFilterChange({endDate: value})}
              format="DD.MM.YYYY"
              allowClear={false}
            />
            <div className="prod-names-filter">
              <Select
                allowClear={false}
                value={filters.productIds}
                onSelect={value => onFilterChange({productIds: [...filters.productIds, value]})}
                onDeselect={value => onFilterChange({productIds: filters.productIds.filter(i => i !== value)})}
                onClear={() => onFilterChange({productIds: []})}
                options={products.map(product => ({
                  value: product.id,
                  label: product.name
                }))}
                className="prod-filters-select"
                placeholder="Все"
                tagRender={customTagRender}
                mode="multiple"
                maxTagCount="responsive"
              />
            </div>
             <Select
              allowClear={false}
              value={filters.employeeType}
              onSelect={value => onFilterChange({employeeType: value})}
              options={employeeType}
              className="filters-select"
              placeholder="Все сотрудники"
              tagRender={customTagRender}
            />
            <Radio.Group
              className="radio-price"
              options={priceType}
              value={filters.priceFilterType}
              optionType="button"
              buttonStyle="solid"
              size={ isMobile ? "small" : "middle" }
              onChange={e => onFilterChange({priceFilterType: e.target.value})}
            />
            <Button onClick={onRefresh} size={isMobile ? "small" : "middle"}>Обновить</Button>
            <div style={{display: "grid", gridTemplateColumns: "60px 60px", gap:"8px"}}>  
              <PrintButton onClick={handlePrint}/>
              <ExportExcelButton onClick={handleExport} />
            </div>
          </div>
        </div>
      )
  );
}

export default RepProductReportHeader;
